import styled from "styled-components";
import { fonts, colors, sizing, shadows } from "../../../styles/variables.js";
import Button from "../../../styles/Button.js";
import { motion } from "framer-motion";

export const Header = styled.header`
   padding: 3.2rem 0;
   display: flex;
   align-items: center;
   height: 90vh;
   min-height: 30rem;
   max-height: 36rem;

   @media (max-width: 900px) {
      flex-direction: column;
      justify-content: center;
      height: 100%;
      min-height: 100%;
      max-height: 100%;
      padding: 3.4rem 0 2rem;
   }

   @media (max-width: 700px) {
      min-height: 34rem;
   }

   @media (max-device-width: 310px) {
      min-height: 38rem;
   }
`;

export const HeaderDetails = styled.div`
   flex: 1;
   margin-right: 1rem;
   margin-top: -2rem;

   @media (max-width: 900px) {
      margin-left: 1rem;
      margin-right: 0;
      margin-top: 0;
   }

   @media (max-width: 600px) {
      margin-top: 0;
   }

   .main-heading {
      @media (max-width: 600px) {
         margin-bottom: 0.3rem;
      }
   }

   .detail {
      margin-top: 0.8rem;
      @media (max-width: 600px) {
         margin-top: 1.2rem;
      }
   }
`;

export const HeaderEmail = styled.div`
   display: flex;
   align-items: center;
   margin: 2rem 0;
   flex-wrap: wrap;

   @media (max-width: 600px) {
      margin-top: 2.2rem;
      margin-bottom: 2rem;
   }

   .email-label {
      font-weight: 500;
      font-size: 1rem;
      margin-right: 0.8rem;

      @media only screen and (max-device-width: 300px) and (orientation: portrait) {
         margin-bottom: 0.4rem;
      }
   }

   .email {
      text-decoration: none;
      font-size: 1rem;
      font-family: ${fonts.default};
      font-weight: 400;
      color: ${colors.link};

      &:hover {
         text-decoration: underline;
      }

      @media (max-width: 1000px) {
         font-size: 0.9rem;
      }
   }
`;

export const HeaderSocialIcons = styled.div`
   width: 14rem;
   display: none;
   margin-bottom: 3rem;

   @media (max-width: 800px) {
      display: block;
   }
`;

export const HeaderButtons = styled.div`
   display: flex;
   align-items: center;
`;

export const ImageGrid = styled.div`
   flex: 1;
   display: grid;
   grid-template-areas:
      "one icons"
      "one three"
      "two three";
   grid-template-columns: 1fr 1fr;
   grid-template-rows: 7.4rem 6rem 9rem;
   gap: 1rem;

   @media (max-width: 900px) {
      display: none;
   }

   .grid-img {
      height: 100%;
      box-shadow: 0 4px 16px #dfdfdf;
      border-radius: ${sizing.borderRadius4};

      img {
         object-position: center 0 !important;
      }
   }

   .one {
      grid-area: one;
   }

   .two {
      grid-area: two;
   }

   .three {
      grid-area: three;
   }

   .icons {
      grid-area: icons;
   }
`;

export const GridItem = styled(motion.div)`
   width: 100%;
   height: 100%;
   position: relative;
`;

export const Buttons = styled.div`
   position: absolute;
   display: none;
`;

export const GridIcons = styled(motion.div)`
   height: 100%;
   display: grid;
   grid-template-columns: 1fr 1fr 1fr;
   grid-template-rows: 1fr 1fr;
   gap: 1rem;
   align-items: center;
   justify-items: center;
   padding: 0.2rem;

   img {
      object-fit: contain;
      width: 80%;
      height: 90%;
   }
`;

export const DownArrow = styled.div`
   display: none;
   width: 3.5rem;
   height: auto;
   margin-top: 4rem;

   @media (max-width: 900px) {
      display: block;
   }

   img {
      width: 100%;
   }
`;
